// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3GoT8","row":"Node_row__V2NHu","label":"Node_label__1ZNyN","footer":"Node_footer__3C-i-"};